import { currentCountry } from '@rcg/ui-react';
import RCCL_UUID from '@rcg/uuid';

const ENABLE_NEW_PAYMENT_LAYOUT = 'enable-new-payment-layout';
const LD_SESSION_STORAGE_KEY = 'ldAirFlags';
const ENABLE_GIFT_CARDS_PAYMENT = 'enable-gift-cards-payment';
const ENABLE_GIFT_CARD_TOKENIZATION = 'enable-gift-card-tokenization';
const ENABLE_3DS_PAYMENT_GATEWAY = 'enable-3ds-payment-gateway';
const ENABLE_UNIFIED_PAYMENT = 'enable-unified-payment-component';
const ENABLE_ONE_WAY = 'enable-one-way';
const ENABLE_SIGN_IN = 'enable-sign-in';
const ENABLE_MANAGEFLIGHTS = 'enable-manage-flights';

const key = (country, ldSessionFlags = LD_SESSION_STORAGE_KEY) => {
  return `${ldSessionFlags}_${country}`;
};

const LDUser = () => {
  let user = RCCL_UUID.getRWDId();
  if (!user) {
    RCCL_UUID.createRWDId();
    user = RCCL_UUID.getRWDId();
  }
  return user;
};

const hasLDFlags = () => !!sessionStorage.getItem(key(currentCountry()));

const setLDFlags = (flags, ldSessionFlags = LD_SESSION_STORAGE_KEY) => {
  const country = currentCountry();
  Object.entries(sessionStorage).forEach(([ssKey]) => {
    if (key(country, ldSessionFlags) !== ssKey && ssKey.startsWith(ldSessionFlags)) {
      sessionStorage.removeItem(ssKey);
    }
  });
  if (flags?.ldAirFlags) {
    sessionStorage.setItem(key(country, ldSessionFlags), JSON.stringify(flags.ldAirFlags));
  }
  if (flags?.ldFlags) {
    sessionStorage.setItem(key(country, ldSessionFlags), JSON.stringify(flags.ldFlags));
  }
};

const getLDFlag = (ldFlagName) => {
  const ldFlags = sessionStorage.getItem(key(currentCountry()));
  const flags = ldFlags && JSON.parse(ldFlags);
  return flags && flags[ldFlagName];
};

export {
  getLDFlag,
  hasLDFlags,
  setLDFlags,
  LDUser,
  ENABLE_3DS_PAYMENT_GATEWAY,
  ENABLE_GIFT_CARD_TOKENIZATION,
  ENABLE_ONE_WAY,
  ENABLE_NEW_PAYMENT_LAYOUT,
  ENABLE_MANAGEFLIGHTS,
  ENABLE_SIGN_IN,
  ENABLE_GIFT_CARDS_PAYMENT,
  ENABLE_UNIFIED_PAYMENT,
};
